import React from 'react'


function PdfFile() {
  return (
    <div>
        <button className="about-button">
            <a href="Drusilla-Khulwael-Resume.pdf" download="Drusilla.pdf">Download my CV</a>
        </button>
    </div>
  )
}

export default PdfFile